export default __webpack_public_path__ + "static/media/original-preview1.2eda5b32.gif";